import { IResourceComponentsProps, useNotification } from "@pankod/refine-core";
import {
  Create,
  useForm,
} from "@pankod/refine-antd";
import { IUsers } from "interfaces";
import { UsersForm } from "components/forms";

export const UsersCreate: React.FC<IResourceComponentsProps> = () => {
  const notification = useNotification();
  const { formProps, saveButtonProps, queryResult } = useForm<IUsers>({
    onMutationSuccess: (data) => {
      const error = (data as any)?.data?.error;
      const detail = (data as any)?.data?.detail;
      if (error || detail) {
        notification.open?.({
          message: error || detail,
          type: "error",
        });
        return;
      }
      const message = (data as any)?.data?.message || "Usuário criado com sucesso.";
      notification.open?.({
        message,
        type: "success",
      });
    },
    onMutationError: (error) => {
      const message = (error as any)?.response?.data?.detail || (error as any)?.response?.data?.message || (error as any)?.response?.data?.error || (error as any)?.message || "Erro ao criar usuário.";
      notification.open?.({
        message,
        type: "error",
      });
    },
    successNotification: false,
    errorNotification: false,
  });
  return (
    <Create saveButtonProps={saveButtonProps}>
      <UsersForm
        formProps={formProps}
        queryResult={queryResult}
      />
    </Create>
  );
};
